import { render, staticRenderFns } from "./communicationList.vue?vue&type=template&id=17d23547&scoped=true"
import script from "./communicationList.vue?vue&type=script&lang=js"
export * from "./communicationList.vue?vue&type=script&lang=js"
import style0 from "./communicationList.vue?vue&type=style&index=0&id=17d23547&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d23547",
  null
  
)

export default component.exports